const APP_NAME = "Inchanted";
export const DEFAULT_META_DESCRIPTION = "Web site created for Inchanted";

export const ROUTE_TITLE_CONFIG = [
  {
    pathPrefix: "/reusable-link/",
    pageTitle: "document(s) link",
    pageManagesTitle: true,
  },
];

const getRouteTitleConfig = (pathname) =>
  ROUTE_TITLE_CONFIG.find(({ pathPrefix }) => pathname.startsWith(pathPrefix));

export const isTitleManagedByPage = (pathname) =>
  getRouteTitleConfig(pathname)?.pageManagesTitle || false;

export const getDocumentTitle = (pathname, detail) => {
  const routeTitle = getRouteTitleConfig(pathname)?.pageTitle;
  const normalizedDetail = typeof detail === "string" ? detail.trim() : "";

  return [APP_NAME, routeTitle, normalizedDetail].filter(Boolean).join(" - ");
};

export const getAgencyDescription = (agencyName) => {
  const normalizedAgencyName =
    typeof agencyName === "string" ? agencyName.trim() : "";

  return normalizedAgencyName ? `Agency - ${normalizedAgencyName}` : "Agency";
};
